import { defineMessages } from 'react-intl';

const messages = defineMessages({
  assetsClearFiltersButtonLabel: {
    id: 'assetsClearFiltersButtonLabel',
    defaultMessage: 'Clear all filters',
    description: 'Label for a button that clears all filters applied to a table.',
  },
});

export default messages;
